import { render, staticRenderFns } from "./ImpresionListaAbordaje.vue?vue&type=template&id=0a4625ea&"
import script from "./ImpresionListaAbordaje.vue?vue&type=script&lang=js&"
export * from "./ImpresionListaAbordaje.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports